export default __webpack_public_path__ + "static/media/1779_bar_tn.97f0e1d1.jpg";